"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const server_1 = require("react-dom/server");
const react_i18next_1 = require("react-i18next");
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ templateName, TemplateContents, TemplateGuide, insertTemplate, }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleClose = () => setOpen(false);
    const onAddTemplateClick = () => {
        insertTemplate((0, server_1.renderToStaticMarkup)(TemplateContents()));
        handleClose();
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ClickAwayListener_1.default, Object.assign({ onClickAway: handleClose }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ open: open, placement: "bottom-start", title: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '10px' } }, { children: [TemplateGuide && (0, jsx_runtime_1.jsx)(TemplateGuide, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                                p: {
                                    lineHeight: '26px',
                                    fontSize: '15px',
                                    color: 'rgba(0, 0, 0, 0.8)',
                                },
                            } }, { children: (0, jsx_runtime_1.jsx)(TemplateContents, {}) })), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ fullWidth: true, sx: {
                                height: '32px',
                                p: '0 10px',
                                border: '1px solid rgba(0, 0, 0, 0.8)',
                                fontSize: '15px',
                                fontWeight: 'bold',
                                color: 'rgba(0, 0 ,0, 0.8)',
                                bgcolor: 'white !important',
                            }, onClick: onAddTemplateClick }, { children: ["+ ", t('추가하기')] }))] })), arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, 
                // ! sx not working properly
                // ? https://github.com/mui/material-ui/issues/28679#issuecomment-949277606
                componentsProps: {
                    tooltip: {
                        sx: {
                            width: '240px',
                            p: '10px',
                            border: '1px solid var(--gray-20)',
                            borderRadius: '8px',
                            mt: '8px !important',
                            bgcolor: 'var(--white)',
                            boxShadow: '0px 5px 10px 0px #0000000D',
                            '.MuiTooltip-arrow': {
                                color: 'var(--white)',
                                '&::before': {
                                    border: '1px solid var(--gray-20)',
                                    bgcolor: 'var(--white)',
                                },
                            },
                        },
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ value: "open", selected: open, onClick: () => setOpen(!open), sx: {
                        height: '32px',
                        p: '0 12px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '6px',
                        fontSize: '15px',
                        fontWeight: 'bold',
                        bgcolor: 'var(--white) !important',
                        color: 'var(--gray-80)',
                    } }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", templateName] })) })) })) }) })));
}
exports.default = default_1;
